import React from 'react'
import PropTypes from 'prop-types'

import * as S from './styled'

const KenburnedImage = ({ src, ...rest }) => (
  <S.Container {...rest}>
    <S.Illustration className={'illustration kenburns-image'} src={src} />
  </S.Container>
)

KenburnedImage.defaultProps = {
  src: '',
}

KenburnedImage.propTypes = {
  src: PropTypes.string.isRequired,
}

export default KenburnedImage
